import { render } from "./VehiclePackageInfo.vue?vue&type=template&id=31560573&scoped=true"
import script from "./VehiclePackageInfo.vue?vue&type=script&lang=js"
export * from "./VehiclePackageInfo.vue?vue&type=script&lang=js"

import "./VehiclePackageInfo.vue?vue&type=style&index=0&id=31560573&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31560573"]])

export default __exports__